<template>
  <v-app>
    <v-toolbar color="primary" dark fixed>
      <div class="icon">
        <v-img :src="icon"></v-img>
      </div>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-btn flat icon to="/">
          <v-icon>home</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-container class="mt-5">
      <v-layout justify-center>
        <v-flex class="xs12 sm10 md8 lg6 xl6">
          <router-view class="mt-3" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      icon: require('./assets/mmmcom.png'),
    }
  },
}
</script>

<style scoped>
.icon {
  height:38px;
  width:38px;
}
</style>

